const osAndroid = {
  id: "android",
  label: "Android",
  iconClass: "fa-android",
};
const osChrome = {
  id: "cros",
  label: "ChromeOS",
  iconClass: "fa-chrome",
};
const osLinux = {
  id: "linux",
  label: "Linux",
  iconClass: "fa-linux",
};
const osMac = {
  id: "mac",
  label: "MacOS",
  iconClass: "fa-apple",
};
const osWeb = {
  id: "webos",
  label: "WebOS",
  iconClass: "fa-tv",
};
const osWindows = {
  id: "win32",
  label: "Windows",
  iconClass: "fa-windows",
};

const osMetaMap = {};
const rawOsMetaMap = {
  osAndroid,
  osChrome,
  osLinux,
  osMac,
  osWeb,
  osWindows,
};

Object.keys(rawOsMetaMap).forEach((osConst) => {
  const osMeta = rawOsMetaMap[osConst];
  osMetaMap[osMeta.id] = osMeta;
});

export default osMetaMap;
export { osAndroid, osChrome, osLinux, osMac, osWeb, osWindows };
